<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1" style="margin: 0px">{{ tajukKad }}</p>
          <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; width: 100%;" v-if="!oilcompanyLocked">
            <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center; flex: 1;">
              <el-button style="padding: 12px 24px;" @click="()=>saveAndNavigate('fleetcard/mulatambahsyarikatminyak')" type="primary">
                <i class="el-icon-plus" style="margin-right: 5px;"/> Pilih Syarikat Minyak
              </el-button>
            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <!-- <div class="dashboardSectionCard" style="align-items: flex-start;" v-if="profileVehicleType === 'awam' || profileVehicleType === 'awambarangan'">
            <p style="margin: 0px; font-weight: bold; font-size: 20px; margin-bottom: 5px;">Awam</p>
            <el-table
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="awamOilcompanyArray"
              v-loading.body="loading"
              element-loading-text="Loading"
              @sort-change="sortChange"
              fit
              highlight-current-row
            >
              <el-table-column
                label="No."
                width="50" type="index" :index="indexMethod">
              </el-table-column>
              <el-table-column
                prop="oilcompanyName"
                label="Syarikat Minyak">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center;">
                    <div class="iconBackground" style="margin-right: 10px; width: 34px; height: 34px; padding: 2px;" :class="getOilCompanyKeyByName(scope.row.oilcompanyName)">
                      <div class="oilcompanyIconBackground">
                        <img class="oilcompanyIcon" :src="getOilCompanyIconByName(scope.row.oilcompanyName)" :style="getOilCompanyStyleByName(scope.row.oilcompanyName)"/>
                      </div>
                    </div>
                    <span style="word-break: break-word;">{{ scope.row.oilcompanyName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="oilcompanyPercentage"
                label="Pecahan (%)"
                width="200">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                    <span>{{ scope.row.oilcompanyPercentage }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dashboardSectionCard" style="align-items: flex-start;" v-if="profileVehicleType === 'barangan' || profileVehicleType === 'awambarangan'">
            <p style="margin: 0px; font-weight: bold; font-size: 20px; margin-bottom: 5px;">Barangan</p>
            <el-table
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="baranganOilcompanyArray"
              v-loading.body="loading"
              element-loading-text="Loading"
              @sort-change="sortChange"
              fit
              highlight-current-row
            >
              <el-table-column
                label="No."
                width="50" type="index" :index="indexMethod">
              </el-table-column>
              <el-table-column
                prop="oilcompanyName"
                label="Syarikat Minyak">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center;">
                    <div class="iconBackground" style="margin-right: 10px; width: 34px; height: 34px; padding: 2px;" :class="getOilCompanyKeyByName(scope.row.oilcompanyName)">
                      <div class="oilcompanyIconBackground">
                        <img class="oilcompanyIcon" :src="getOilCompanyIconByName(scope.row.oilcompanyName)" :style="getOilCompanyStyleByName(scope.row.oilcompanyName)"/>
                      </div>
                    </div>
                    <span style="word-break: break-word;">{{ scope.row.oilcompanyName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="oilcompanyPercentage"
                label="Pecahan (%)"
                width="200">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                    <span>{{ scope.row.oilcompanyPercentage }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div> -->
          <div class="dashboardSectionCard" style="align-items: flex-start;" v-if="profileVehicleType === 'awam' || profileVehicleType === 'barangan' || profileVehicleType === 'awambarangan'">
            <p style="margin: 0px; font-weight: bold; font-size: 20px; margin-bottom: 5px;">{{ profileVehicleType | formatProfileVehicleType }}</p>
            <el-table
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="awamOilcompanyArray"
              v-loading.body="loading"
              element-loading-text="Loading"
              @sort-change="sortChange"
              fit
              highlight-current-row
            >
              <el-table-column
                label="No."
                width="50" type="index" :index="indexMethod">
              </el-table-column>
              <el-table-column
                prop="oilcompanyName"
                min-width="100"
                label="Syarikat Minyak">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center;">
                    <div class="iconBackground" style="margin-right: 10px; width: 34px; height: 34px; padding: 2px;" :class="getOilCompanyKeyByName(scope.row.oilcompanyName)">
                      <div class="oilcompanyIconBackground">
                        <img class="oilcompanyIcon" :src="getOilCompanyIconByName(scope.row.oilcompanyName)" :style="getOilCompanyStyleByName(scope.row.oilcompanyName)"/>
                      </div>
                    </div>
                    <span style="word-break: break-word;">{{ scope.row.oilcompanyName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="oilcompanyPercentage"
                label="Pecahan (%)"
                width="200">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                    <span>{{ scope.row.oilcompanyPercentage }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <template v-if="registerForm.fleetcardSubmittedFlagPetrol">
            <p class="el-input-size" style="color: #cc0000">**Tekan butang Surat Kelulusan dan Senarai Kenderaan bagi menjana dokumen-dokumen anda.</p>
            <div class="el-button-mobile-container">
              <el-button type="primary" @click="printSuratKelulusan"><i class="el-icon-document"></i> Surat Kelulusan</el-button>
              <el-button type="primary" @click="printSuratSenaraiKenderaan"><i class="el-icon-document"></i> Senarai Kenderaan</el-button>
            </div>
          </template> -->
        </div>
      </div>
      <div class="cardOverlay" v-if="requiresVehicle">
        <div class="cardOverlayContent">
          <span style="margin-top: 0px;">Sila pilih kenderaan</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import suratkelulusanawam from '../suratkelulusanawam'
import suratsenaraikenderaan from '../suratsenaraikenderaan'
import letterheadkpdn from '@/assets/letterheadkpdn.png'
export default {
  name: 'oil-company-new',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false,
      suratkelulusanawam,
      suratsenaraikenderaan,
    }
  },
  methods: {
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    },
    async navigateToWebPage(webpage) {
      this.$router.push(`/z/${this.$store.state.app.branchSelected}/mypetrol/${webpage}`)
    },
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    oilcompanyArray: {
      type: Array
    },
    vehicleArray: {
      type: Array
    },
    searchKenderaan: {
      type: String
    },
    saveAndNavigate: {
      type: Function
    },
    locked: {
      type: Boolean
    },
    oilcompanyLocked: {
      type: Boolean
    },
    registerForm: {
      type: Object
    },
    requiresVehicle: {
      type: Boolean
    },
    profileVehicleType: {
      type: String
    },
    loading: {
      type: Boolean
    }
  },
  methods: {
    indexMethod(index) {
      return index + 1
    },
    sortChange({ prop, order }) {
      this.$emit('sortChange', { prop, order })
    },
    printSuratKelulusan() {
      const now = moment()
      const dateFormatted = now.format('DD/MM/YYYY')
      const nextMonth = now.clone().add(1, 'days').add(1, 'months').set({
        date: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).format('DD/MM/YYYY')
      const vehicleList = this.vehicleArray.filter((vehicle) => vehicle.vehicleActiveTickedFlag == true && now.isBefore(vehicle.vehicleRoadTaxEndDate) && !vehicle.vehicleRestrictionFlag).map((v) => {
        return {
          ...v,
          vehicleRoadTaxEndDate: moment(v.vehicleRoadTaxEndDate).format('DD/MM/YYYY'),
        }
      })
      const content = suratkelulusanawam.content(
        this.registerForm,
        vehicleList,
        this.oilcompanyArray,
        dateFormatted,
        nextMonth,
        this.branchRole === 'Owner' ? false : true
      )
      let printWindow = window.open('', '_blank');
      printWindow.document.open();
      printWindow.document.write(content);
      printWindow.document.close();
      printWindow.onload = function () {
        const img = printWindow.document.getElementById('letterhead');
        if (img.complete) {
          printWindow.print();
          // printWindow.close();
        } else {
          img.onload = function () {
              printWindow.print();
              // printWindow.close();
          };
          img.onerror = function () {
              alert('Failed to load image.');
              // printWindow.close();
          };
        }
      };
      // printWindow.onafterprint = function () { printWindow.close(); };
    },
    printSuratSenaraiKenderaan() {
      const now = moment()
      const dateFormatted = now.format('DD/MM/YYYY')
      const newTime = now.clone().add(1, 'months')
      const month = newTime.month()
      const year = newTime.year()
      let monthLabel = ''
      switch (month) {
        case 0:
          monthLabel = 'JANUARI'
          break
        case 1:
          monthLabel = 'FEBRUARI'
          break
        case 2:
          monthLabel = 'MAC'
          break
        case 3:
          monthLabel = 'APRIL'
          break
        case 4:
          monthLabel = 'MEI'
          break
        case 5:
          monthLabel = 'JUN'
          break
        case 6:
          monthLabel = 'JULAI'
          break
        case 7:
          monthLabel = 'OGOS'
          break
        case 8:
          monthLabel = 'SEPTEMBER'
          break
        case 9:
          monthLabel = 'OKTOBER'
          break
        case 10:
          monthLabel = 'NOVEMBER'
          break
        case 11:
          monthLabel = 'DISEMBER'
          break
      }
      const monthYear = monthLabel + ' ' + year
      console.log('this.vehicleArray', this.vehicleArray)
      const vehicleListA = this.vehicleArray.filter((vehicle) => {
        const sector = vehicle.vehiclebodytypeId && vehicle.vehiclebodytypeId.bodytypeSector ? vehicle.vehiclebodytypeId.bodytypeSector : vehicle.vehicleBodyTypeSector
        return vehicle.vehicleActiveTickedFlag == true && now.isBefore(vehicle.vehicleRoadTaxEndDate) && !vehicle.vehicleRestrictionFlag && sector === 'awam'}).map((v) => {
        return {
          ...v,
          vehicleRoadTaxEndDate: moment(v.vehicleRoadTaxEndDate).format('DD/MM/YYYY'),
        }
      })
      const vehicleListB = this.vehicleArray.filter((vehicle) => {
        const sector = vehicle.vehiclebodytypeId && vehicle.vehiclebodytypeId.bodytypeSector ? vehicle.vehiclebodytypeId.bodytypeSector : vehicle.vehicleBodyTypeSector
        return vehicle.vehicleActiveTickedFlag == true && now.isBefore(vehicle.vehicleRoadTaxEndDate) && !vehicle.vehicleRestrictionFlag && sector === 'barangan'}).map((v) => {
        return {
          ...v,
          vehicleRoadTaxEndDate: moment(v.vehicleRoadTaxEndDate).format('DD/MM/YYYY'),
        }
      })
      const content = suratsenaraikenderaan.content(
        this.registerForm,
        vehicleListA,
        vehicleListB,
        this.oilcompanyArray,
        dateFormatted,
        monthYear
      )
      let printWindow = window.open('', '_blank');
      printWindow.document.open();
      printWindow.document.write(content);
      printWindow.document.close();
      printWindow.onload = function () {
        const img = printWindow.document.getElementById('letterhead');
        if (img.complete) {
          printWindow.print();
          // printWindow.close();
        } else {
          img.onload = function () {
              printWindow.print();
              // printWindow.close();
          };
          img.onerror = function () {
              alert('Failed to load image.');
              // printWindow.close();
          };
        }
      };
      // printWindow.onafterprint = function () { printWindow.close(); };
    },
   getOilCompanyKeyByName(oilcompanyName) {
      switch (oilcompanyName) {
        case 'BHP': {
          return 'bhp'
        }
        case 'CALTEX (CHEVRON)': {
          return 'caltex'
        }
        case 'FIVE': {
          return 'five'
        }
        case 'PETRON MALAYSIA': {
          return 'petron'
        }
        case 'PETRONAS': {
          return 'petronas'
        }
        case 'SHELL': {
          return 'shell'
        }
      }
      return null
    },
    getOilCompanyIconByName(oilcompanyName) {
      switch (oilcompanyName) {
        case 'BHP': {
          return require('@/assets/bhplogo.png')
        }
        case 'CALTEX (CHEVRON)': {
          return require('@/assets/caltexlogo.png')
        }
        case 'FIVE': {
          return require('@/assets/fivelogo.png')
        }
        case 'PETRON MALAYSIA': {
          return require('@/assets/petronlogo.png')
        }
        case 'PETRONAS': {
          return require('@/assets/petronaslogo.png')
        }
        case 'SHELL': {
          return require('@/assets/shelllogo.svg')
        }
      }
      return null
    },
    getOilCompanyStyleByName(oilcompanyName) {
      switch (oilcompanyName) {
        case 'BHP': {
          return {
            width: '24px',
            height: '24px',
          }
        }
        case 'CALTEX (CHEVRON)': {
          return {
            width: '22px',
            height: '22px',
          }
        }
        case 'FIVE': {
          return {
            width: '24px',
            height: '24px',
          }
        }
        case 'PETRON MALAYSIA': {
          return {
            width: '22px',
            height: '22px',
          }
        }
        case 'PETRONAS': {
          return {
            width: '20px',
            height: '20px',
          }
        }
        case 'SHELL': {
          return {
            width: '24px',
            height: '24px',
          }
        }
      }
      return {
        width: '24px',
        height: '24px',
      }
    },
  },
  filters: {
    formatDateTime(val) {
      if (val !== undefined) {
        return moment.unix(Number(val)).format('DD/MM/YYYY HH:mm')
      }
      return ''
    },
    formatDate(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      }
      return '-'
    },
    formatNumber(val) {
      if (val !== null && val !== undefined) {
        return val.toLocaleString('en')
      }
      return '-'
    },
    formatProfileVehicleType(val) {
      switch (val) {
        case 'awambarangan': return 'AWAM & BARANGAN'
        case 'awam': return 'AWAM'
        case 'barangan': return 'BARANGAN'
        default: return '-'
      }
    },
  },
  computed: {
    kenderaanKuotaAsa() {
      return Number(this.vehicleArray.reduce((acc, item) => {
        const value = Number(item.vehicleQuotaBase) ? Number(item.vehicleQuotaBase) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    kenderaanKuotaSemasa() {
      return Number(this.vehicleArray.reduce((acc, item) => {
        const value = Number(item.vehicleQuotaCurrent) ? Number(item.vehicleQuotaCurrent) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    awamOilcompanyArray() {
      return this.oilcompanyArray.filter((oilcompany) => {
        return oilcompany.oilcompanyProfileVehicleType === 'awam'
      })
    },
    baranganOilcompanyArray() {
      return this.oilcompanyArray.filter((oilcompany) => {
        return oilcompany.oilcompanyProfileVehicleType === 'barangan'
      })
    },
    branchRole() {
      return this.$store.state.user.branchData && this.$store.state.user.branchData.relation && this.$store.state.user.branchData.relation.role ? this.$store.state.user.branchData.relation.role : null
    },
  },
  mounted() {
    console.log('this.handleVehicleDelete', this.handleVehicleDelete)
  }
}
</script>


// WEBPACK FOOTER //
// src/views/mypetrol/components/OilCompanyNew.vue